module.exports = __webpack_public_path__ + "themes/fq/img/button.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/button.png
// module id = 57
// module chunks = d-game